export default function DatePicker(props: {
  label: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
  required?: boolean;
  error?: string;
  onBlur?: () => void;
  className?: string;
}) {
  return (
    <div className="flex-grow">
      <div className={`flex w-full flex-col gap-1 ${props.className}`}>
        <label htmlFor={props.label}>{props.label}</label>
        <input
          type="date"
          id={props.label}
          value={props.value}
          onChange={(e) => props.onChange(e.target.value)}
          onBlur={props.onBlur}
          disabled={props.disabled}
          required={props.required}
          className={`w-full rounded-md border p-1 ${
            props.error ? "border-red-500" : ""
          }`}
        />
        {props.error && <p className="text-sm text-red-500">{props.error}</p>}
      </div>
    </div>
  );
}
